module.exports = __webpack_public_path__ + "static/img/imgAct.1d4ded8c.png";